const formatShotScore=(score: number | undefined | null): string =>{
  return score != null ? score.toString() : '-';
}

const formatHitRatioV1 = (n_hits: number = 0, hits_ratio?: number): string => {
  if (!hits_ratio || hits_ratio <= 0) return `${n_hits}/0`;
  const total = Math.round(n_hits / hits_ratio);
  return `${n_hits}/${total}`;
};

const formatHitRatioV2 = (n_hits?: number, n_shots?: number): string => {
  if (!n_shots || n_shots <= 0) return `${n_hits ?? 0}/0`;
  return `${n_hits ?? 0}/${n_shots}`;
};

const formatHitFactor=(hitFactor: number | undefined | null): string =>{
  return hitFactor !== null && hitFactor !== undefined ? hitFactor.toFixed(2) : '-';
}

const formatAccuracy=(score: number | undefined | null): string =>{
  return score !== null && score !== undefined
    ? score.toFixed(2)
    : '-';
}

const formatDuration=(seconds: number | undefined | null): string =>{
  if (seconds === null || seconds === undefined || seconds < 0) return '-';

  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);

  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
}

const calculateDurationLabel = (start?: string, end?: string | null): string => {
  if (!start || !end) return 'N/A';
  const startDate = new Date(start);
  const endDate = new Date(end);
  if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) return 'N/A';

  const diff = endDate.getTime() - startDate.getTime();
  if (diff < 0) return '-';

  const minutes = Math.floor(diff / 60000);
  const seconds = Math.floor((diff % 60000) / 1000);

  return `${minutes.toString().padStart(2, '0')}m ${seconds.toString().padStart(2, '0')}s`;
};

const formatDurationMs = (seconds?: number | null): string => {
  if (seconds == null || seconds < 0) return '-';
  return `${seconds.toFixed(2)}s`;
};

export {
  formatShotScore,
  formatHitRatioV1,
  formatHitRatioV2,
  formatHitFactor,
  formatAccuracy,
  formatDuration,
  calculateDurationLabel,
  formatDurationMs
};